import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import WorkProfileProvider from "./WorkProfileProvider";
import { MenuStatusList } from "../../../model/work_profile/MenuStatusListModel";
import { useDispatch } from "react-redux";
import {
  addModal,
  removeAllModal,
} from "../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../const/ModalKeys";

type WorkProfileTypes = {
  menus: Array<WorkProfileMenus>;
  getWorkMenuAPI: () => void;
  handleClick: (name: "automated_reply" | "my_messages") => void;
};

type WorkProfileMenus = {
  icon: string;
  name: "automated_reply" | "my_messages";
  status: boolean;
};

const WorkProfileContext = createContext<WorkProfileTypes | undefined>(
  undefined
);

export const WorkProfileContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const dispatch = useDispatch();

  const workProfileMenus: Array<WorkProfileMenus> = [
    { icon: "automated", name: "automated_reply", status: false },
    { icon: "messages", name: "my_messages", status: false },
  ];

  const [menus, setMenus] = useState<Array<WorkProfileMenus>>(workProfileMenus);

  const getWorkMenuAPI = async () => {
    const menuStatusListResult: MenuStatusList | null =
      await WorkProfileProvider.getWorkMenuAPI();

    let menusTemp: Array<WorkProfileMenus> = [];
    if (menuStatusListResult != null) {
      workProfileMenus.forEach((menu) => {
        let status: boolean = menu.status;

        if (menu.name === "automated_reply") {
          status = menuStatusListResult.automated_reply_status === "1";
        } else if (menu.name === "my_messages") {
          status = menuStatusListResult.my_messages_status === "1";
        }

        menusTemp.push({
          ...menu,
          status: status,
        });
      });
    }

    setMenus(menusTemp);
  };

  const handleClick = (name: "automated_reply" | "my_messages") => {
    dispatch(removeAllModal());
    if (name === "automated_reply") {
      dispatch(addModal({ id: ModalKeys.work_automated_reply, title: name }));
    } else if (name === "my_messages") {
      dispatch(addModal({ id: ModalKeys.work_my_messages }));
    }
  };

  useEffect(() => {
    getWorkMenuAPI();
    // eslint-disable-next-line
  }, []);

  return (
    <WorkProfileContext.Provider
      value={{
        menus,
        getWorkMenuAPI,
        handleClick,
      }}
    >
      {children}
    </WorkProfileContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const WorkProfileContextImport = () => {
  const context = useContext(WorkProfileContext);
  if (!context) {
    throw new Error(
      "WorkProfileContextImport must be used within a WorkProfileContextProvider"
    );
  }
  return context;
};
